export default __webpack_public_path__ + "static/media/logo-horizontal.e67e5b4d.svg";